module.exports = __webpack_public_path__ + "img/export.ada48fbd.svg";